import React from 'react';
import { RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';

interface ScoreCardProps {
  score: number;
}

const ScoreCard: React.FC<ScoreCardProps> = ({ score }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const startNewEvaluation = () => {
    navigate('/evaluation-options');
  };
  
  const getImageSource = () => {
    if (score >= 80) {
      return '/verde.png';
    } else if (score >= 50) {
      return '/naranja.png';
    } else {
      return '/rojo.png';
    }
  };

  const getImageSourceFondo = () => {
    if (score >= 80) {
      return '/status/cardVerde.svg';
    } else if (score >= 50) {
      return '/status/cardNaranja.svg';
    } else {
      return '/status/cardRojo.svg';
    }
  };
  
  const getMessage = () => {
    if (score >= 80) {
      return t('results.messages.healthy');
    } else if (score >= 50) {
      return t('results.messages.moderate');
    } else {
      return t('results.messages.high');
    }
  };
  
  const getMessageCorto = () => {
    if (score >= 80) {
      return t('results.messages.short.healthy');
    } else if (score >= 50) {
      return t('results.messages.short.moderate');
    } else {
      return t('results.messages.short.high');
    }
  };

  return (
    <div>
      <Card className="p-4 overflow-hidden relative min-h-[190px]"
            style={{
              backgroundImage: `url(${getImageSourceFondo()})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
      >     
        <img 
          src={getImageSource()} 
          alt="Status indicator"
          className="absolute inset-0 w-full h-full object-contain z-0"
        />
        <div className="relative z-10 h-full flex items-center">
          <div className=" pl-2 w-3/4">
            <p className="text-gray-700 text-2xl font-bold">
              {getMessageCorto()}
            </p>
            <p className="text-gray-800 text-5xl font-bold pt-5 pl-5">
              {score}%
            </p>
          </div>
        </div>
      </Card>
     
      <div className="w-full max-w-2xl mb-6 mt-4">
        <p className="text-gray-700 text-lg md:text-xl mb-8 text-center">
          {getMessage()}
        </p>
      </div>

      <Button 
        onClick={startNewEvaluation}
        variant="outline"
        className="w-full flex items-center justify-center"
      >
        <RefreshCw className="w-4 h-4 mr-2" />
        {t('performNewEvaluation')}
      </Button>
    </div>
  );
};

export default ScoreCard;